// import React, { useState } from 'react';
// import Switch from '@mui/material/Switch';
// import FormControlLabel from '@mui/material/FormControlLabel';
// import Typography from '@mui/material/Typography';
// import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid } from '@mui/material';
// import { Button } from 'reactstrap';
// import { useMain } from 'src/views/hooks/useMain';
// import { Box } from '@mui/system';
// import TextInputs from 'src/components/inputs/TextInputs';

// const MaskingSettings = ({ data, refreshData }) => {
//   const { updateOwnerCombinedMasking, setShowMessage } = useMain();
// console.log(data,'dataa')
//   const [isMasked, setIsMasked] = useState(data?.isMasked || false);
//   const [isSalesMasked, setIsSalesMasked] = useState(data?.isSalesMasked || false);
//   const [password, setPassword] = useState('');
//   const [openDialogue, setOpenDialogue] = useState(false);

//   const handleToggleChange = () => {
//     setOpenDialogue(true);
//   };

//   const handleCloseDialogue = () => {
//     setOpenDialogue(false);
//   };

//   const handleMaskToggle = async () => {
//     if (password === '') {
//       setShowMessage({ message: 'Please enter login password', messageType: 'error' });
//       return;
//     }
//     try {
//       const updatedSettings = {
//         isMasked: !isMasked,
//         isSalesMasked: !isSalesMasked,
//         password,
//       };
//       const res = await updateOwnerCombinedMasking(data._id, updatedSettings);
  
//       if (res.statusCode === 200) {
//         setShowMessage({ message: res.message || 'Settings updated successfully', messageType: 'success' });
  
//         // 🔹 UI update ke liye state update
//         setIsMasked(updatedSettings.isMasked);
//         setIsSalesMasked(updatedSettings.isSalesMasked);
//         setPassword('');
//         setOpenDialogue(false);
  
//         // 🔹 Refresh the latest data and force a re-render
//         await refreshData(data._id);
//       } else {
//         setShowMessage({ message: res.message || 'Update failed', messageType: 'error' });
//       }
//     } catch (error) {
//       setShowMessage({ message: error.message || 'Something went wrong', messageType: 'error' });
//     }
//   };
  

//   return (
//     <div style={{ padding: '20px', backgroundColor: '#FAFAFA', borderRadius: '10px', border: '0.5px solid #CFCFCF' }}>
//       <FormControlLabel
//         control={<Switch checked={isMasked && isSalesMasked} onChange={handleToggleChange} />}
//         label="Mask All Information (General & Sales)"
//       />
      
//       <Dialog open={openDialogue} onClose={handleCloseDialogue}>
//         <DialogTitle>Confirm Masking Change</DialogTitle>
//         <DialogContent>
//           <DialogContentText>
//             Are you sure you want to turn masking {isMasked && isSalesMasked ? 'OFF' : 'ON'} for both General and Sales Information?
//           </DialogContentText>
//           <Box style={{ marginTop: '10px' }}>
//             <Grid container spacing={3}>
//               <Grid item xs={12}>
//                 <TextInputs
//                   title={'Login Password'}
//                   name={'password'}
//                   value={password}
//                   handleChange={(e) => setPassword(e.target.value)}
//                   type={'password'}
//                 />
//               </Grid>
//             </Grid>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={handleCloseDialogue}>Cancel</Button>
//           <Button onClick={handleMaskToggle} autoFocus>Confirm</Button>
//         </DialogActions>
//       </Dialog>
//     </div>
//   );
// };

// export default MaskingSettings;

import React, { useState, useEffect } from 'react';
import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Grid, IconButton, InputAdornment } from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { Button } from 'reactstrap';
import { useMain } from 'src/views/hooks/useMain';
import { Box } from '@mui/system';
import TextInputs from 'src/components/inputs/TextInputs';

const MaskingSettings = ({ data, refreshData }) => {
  const { updateOwnerCombinedMasking, setShowMessage } = useMain();

  // Single state for both maskings (since they're controlled together)
  const [masked, setMasked] = useState(false);
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [openDialogue, setOpenDialogue] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // Sync with props when data changes
  useEffect(() => {
    if (data) {
      // Both must be true/false together as per requirements
      setMasked(data.isMasked && data.isSalesMasked);
    }
  }, [data]);

  const handleToggleChange = () => {
    setOpenDialogue(true);
  };

  const handleCloseDialogue = () => {
    setOpenDialogue(false);
    setPassword('');
    setShowPassword(false);
  };

  const handleMaskToggle = async () => {
    if (password === '') {
      setShowMessage({ message: 'Please enter login password', messageType: 'error' });
      return;
    }

    setIsLoading(true);
    try {
      const newMaskedState = !masked;
      const updatedSettings = {
        isMasked: newMaskedState,
        isSalesMasked: newMaskedState, // Both set to same value
        password,
      };

      const res = await updateOwnerCombinedMasking(data._id, updatedSettings);

      if (res.statusCode === 200) {
        setShowMessage({ 
          message: res.message || 'Settings updated successfully', 
          messageType: 'success' 
        });

        // Optimistically update UI
        setMasked(newMaskedState);
        setPassword('');
        setShowPassword(false);
        setOpenDialogue(false);

        // Refresh data from server to ensure sync
        await refreshData(data._id);
      } else {
        setShowMessage({ 
          message: res.message || 'Update failed', 
          messageType: 'error' 
        });
        // Revert UI if server update failed
        setMasked(!newMaskedState);
      }
    } catch (error) {
      setShowMessage({ 
        message: error.message || 'Something went wrong', 
        messageType: 'error' 
      });
      // Revert UI on error
      setMasked(!masked);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div style={{ 
      padding: '20px', 
      backgroundColor: '#FAFAFA', 
      borderRadius: '10px', 
      border: '0.5px solid #CFCFCF' 
    }}>
      <FormControlLabel
        control={
          <Switch 
            checked={masked} 
            onChange={handleToggleChange}
            disabled={isLoading}
          />
        }
        label="Mask All Information (General & Sales)"
      />
      
      <Dialog open={openDialogue} onClose={handleCloseDialogue}>
        <DialogTitle>Confirm Masking Change</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to turn masking {masked ? 'OFF' : 'ON'} for both General and Sales Information?
          </DialogContentText>
          <Box style={{ marginTop: '10px' }}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextInputs
                  title={'Login Password'}
                  name={'password'}
                  value={password}
                  handleChange={(e) => setPassword(e.target.value)}
                  type={showPassword ? 'text' : 'password'}
                  disabled={isLoading}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          onClick={() => setShowPassword((prev) => !prev)}
                          edge="end"
                          disabled={isLoading}
                        >
                          {showPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>
            </Grid>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDialogue} disabled={isLoading}>
            Cancel
          </Button>
          <Button 
            onClick={handleMaskToggle} 
            autoFocus
            disabled={isLoading || password === ''}
          >
            {isLoading ? 'Processing...' : 'Confirm'}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default MaskingSettings;